import React, { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { BiLoaderAlt } from "react-icons/bi";
import './VideoPopup.css';

interface VideoPopupProps {
    toggleModal: () => void;
    videoSrc: string;
    title: string
}
export default function VideoPopup(props: VideoPopupProps) {
    const [videoLoading, setVideoLoading] = useState(true);

    const spinner = () => {
        setVideoLoading(!videoLoading);
    };
    return (
        <section className="modal__bg">
        <div className="modal__align">
          <div className="modal__content">
            <IoCloseOutline
              className="modal__close"
              arial-label="Close modal"
              onClick={props.toggleModal}
            />
            <div className="modal__video-align">
              {videoLoading ? (
                <div className="modal__spinner">
                  <BiLoaderAlt
                    className="modal__spinner-style"
                  />
                </div>
              ) : null}
              <iframe
                className="modal__video-style"
                onLoad={spinner}
                loading="lazy"
                width="800"
                height="500"
                src={props.videoSrc}
                title={props.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </section>
    );
}